import type { RunState } from './RunState';
import type { Player } from '../entities/Player';
import type { EventBus } from '../../core/EventBus';

/**
 * The pocket: a single consumable slot (meta unlock fills it with a Mend at
 * run start; shops may sell into it later). Player-triggered — refuses to
 * waste itself on a full health bar. Healing is curse-aware via Player.heal.
 */
export function usePocket(rs: RunState, player: Player, events: EventBus): boolean {
  if (rs.pocket === null || !player.alive) return false;
  if (player.hp >= player.maxHp) return false;
  const healed = player.heal(2);
  rs.pocket = null;
  events.emit('playerHealed', { amount: healed });
  return true;
}
